export const jobCorpsChecklistItemsV2 = [
  {
    key: 'jobcorpsInfoMeeting',
    label: 'Attend the Job Corps / AmeriCorps information meeting.',
    confirmKey: 'confirmJobcorpsInfoMeeting',
    points: 6,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'jobcorpsCareerPath',
    label: 'Identify a possible career path to follow within the Job Corps/AmeriCorps.',
    confirmKey: 'confirmJobcorpsCareerPath',
    points: 7,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'jobcorpsSiteVisit',
    label: 'Explore and visit the site for which you might want to apply.',
    confirmKey: 'confirmJobcorpsSiteVisit',
    points: 6,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'jobcorpsRecruiterMeeting',
    label: 'Meet with a Job Corps / AmeriCorps recruiter.',
    confirmKey: 'confirmJobcorpsRecruiterMeeting',
    points: 7,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'jobcorpsCompleteApplication',
    label: 'Complete the application packet, including all documentation.',
    confirmKey: 'confirmJobcorpsCompleteApplication',
    points: 8,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'jobcorpsAdmissionDate',
    label: 'Set date of Job Corps/AmeriCorps admission.',
    confirmKey: 'confirmJobcorpsAdmissionDate',
    points: 6,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
];

export const jobCorpsChecklistItems = [
  {
    key: 'jobcorpsMeeting',
    label: '55. Attend the Job Corps / AmeriCorps information meeting.',
    confirmKey: 'confirmJobcorpsMeeting',
    points: 6,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'jobcorpsCareerPath',
    label: '56. Identify a possible career path to follow within the Job Corps/AmeriCorps.',
    confirmKey: 'confirmJobcorpsCareerPath',
    points: 7,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'jobcorpsVisitSite',
    label: '57. Explore and visit the site for which you might want to apply.',
    confirmKey: 'confirmJobcorpsVisitSite',
    points: 6,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'jobcorpsRecruiter',
    label: '58. Meet with a Job Corps / AmeriCorps recruiter.',
    confirmKey: 'confirmJobcorpsRecruiter',
    points: 7,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'jobcorpsCompleteApplication',
    label: '59. Complete the application packet, including all documentation.',
    confirmKey: 'confirmJobcorpsCompleteApplication',
    points: 8,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'jobcorpsAdmissionDate',
    label: '60. Set date of Job Corps/AmeriCorps admission.',
    confirmKey: 'confirmJobcorpsAdmissionDate',
    points: 6,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  ...jobCorpsChecklistItemsV2,
];
